<svelte:head>

	{#if $activity && $activity.settings}
		<title>{$activity.titles[0]}</title>
	<meta name='description' content='{$activity.settings.desc}'>

	<meta name="twitter:site" content="@mspanish">
	<meta name="twitter:title" content="{$activity.titles[0]}">
	<meta name="twitter:description" content="{$activity.settings.desc}">
	<meta name="twitter:creator" content="@mspanish">
	<meta name="twitter:image" content="{$activity.settings.img.replace('../', 'https://talker.netlify.com/')}">
	
	<meta property="og:title" content="{$activity.titles[0]}" />
	<meta property="og:type" content="article" />
	<meta property="og:url" content="https://talker.netlify.com/{$activity.settings.name}.html" />
	<meta property="og:image" content="{$activity.settings.img.replace('../', 'https://talker.netlify.com/')}" />
	<meta property="og:description" content="{$activity.settings.desc}" />
	
	{/if}
</svelte:head>


<Sharing bind:activity=$activity/>
<div class="content is-medium">

  <h1>AAC Graphics: Talker Icons</h1>
  
 <p>When looking for cool images to use with our daughter's talker, we found it difficult to find everything we wanted. We loved many of the SymbolStix, but since they aren't included with Snap Core, found we'd have to pay upwards of $70 just to use them. In fact we found very few free symbol sets for AAC graphics. And many of the things we really needed, like clear ASL symbols for things like "wait", "help", and "ok" - were not good enough.</p>
 
 <p>So we set out to refashion an interesting pictographic language system created 20+ years ago by an ingenious man named Timothée Ingen-Housz as part of his doctoral degree, called the Elephant's Memory. His goal was to create a set of symbols that would serve as the basis for an entirely visual form of language.</p>
 
 <p>We've modified his icons quite heavily, and added color to them. Many we aren't using quite yet, and will surely undergo further revision when we do. The rationale behind using a system as sophisticated as the Elephant's Memory rather than simple 1 off graphics, is that we are trying to develop building blocks for our daughter: ones that will lead to true language development. Cute pictures for AAC phrases may seem appealing short term, but we think a better long term goal is to avoid 1 off images that end up like Chinese Kanji, where the child would need to remember thousands of individual pictures in order to have some semblance of working language. We use these images as building blocks whenever possible, so that concepts like pronouns, verbs, nouns, and even place and time will be easier for the child to recognize.</p>
 
 <p>Our system is far from perfect, but it's a start! We are very <Link href="/topics/about">open to suggestions</Link> and can make the vector files available to anyone who would like to help out. For now our modified graphics are copyrighted © Stacey Reiman 2019, but anyone may use them for non commercial purposes. Just right click on any image below and do "save image as".</p>
 
	<div class="divy">
		<input class="searchy" onkeyup="search()" onfocus="search()"  type="text" value="">
		<button onclick="search()" class="buttony">find</button>
	</div>
 
   <div class="iconsWrap">
   {#if $json}
   {#each $json as entry}
		<div data-name={entry.file.replace('.png', '')} class="icony">
			<img class="icons" src="../img/talker_symbols/{entry.file}">
			{#if $text_on_icons}
			<span class="namey">{entry.file.replace('.png', '').replace('-', ' ').replace('_',' ')}</span>
		{/if}
		</div>
   {/each}
   {:else}
    no images found...
   {/if}
 
 </div>

 <script id="search">
	let search = ()=> {
		let value = document.getElementsByClassName('searchy')[0];
		console.log('search is for '+value.value);
		let images = document.getElementsByClassName('icony');
		for (let image of images) {
			let data = image.getAttribute('data-name');
			
			console.log('data is '+data);
			if (data.includes(value.value)) {
				image.style.display = 'inline-block';
			}
			else {
				image.style.display = 'none';
			}
			if (!value.value) {
				image.style.display = 'inline-block';
			}
		}
	  }
</script> 
  
</div>


<style>
.content {
	padding-top:20px;
	padding-bottom:50px;
} 

</style>

<script>
  import roadtrip from 'roadtrip';
  import Link from '../../components/Link.html';
   import Sharing from '../../components/Sharing.html';

  export default {
  	transitions: { fade },
    store: () => store,
    components: { Link, Sharing
	},
    methods: {
      goto(path) {
        roadtrip.goto(path);
      },
	  updateStore(json) {
	   let activity = {
	"titles": ["AAC Icons and Free Graphics"],
	"subs": ["visual language icons"],
	"file": {
		"value": "icons.html",
		"done": false
	},
	"tags": [],
	"dateRaw": "2019-02-21T19:04:22.815Z",
	"date": "Feb 21 2019",
	"settings": {
		"name": "ok",
		"img": "../img/talker_symbols/go.png",
		"desc": "Our visual language icons for use in an AAC system or lessons, for nonverbal and autistic children.",
		"color": "navy",
		"graphics": []
		}
	}
	  	store.set({json:json,text_on_icons: true, activity:activity});
	  },
	  search() {
		let value = document.getElementsByClassName('searchy')[0];
		console.log('search is for '+value.value);
		let images = document.getElementsByClassName('icony');
		for (let image of images) {
			let data = image.getAttribute('data-name');
			
			console.log('data is '+data);
			if (data.includes(value.value)) {
				image.style.display = 'inline-block';
			}
			else {
				image.style.display = 'none';
			}
			if (!value.value) {
				image.style.display = 'inline-block';
			}
		}
	  }
    }, 
	oncreate() {
		const comp = this;
		const urly = 'talker_graphics.json';
		return fetch(urly).then(function(res) {
		return res.text();
			})
			.then(function(json) {
			json = JSON.parse(json);	
			comp.updateStore(json)
		})
	
	}
  }
</script>